// extracted by mini-css-extract-plugin
export var quantityInput = "_kf-0";